import React, { useEffect, useRef, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Alert, Button, Card, CardBody, Row } from "reactstrap";
import { urlCreaFacturacionAP, urlListarCoberturasAp, urlListarProductosAp, urlObtenerPagadoresAP, urlObtenerPlanesAP } from "../../constants/urls";
import ContainerApFacturacion from "./ContainerApFacturacion";
import { useToasts } from 'react-toast-notifications';
import { useLocation, useHistory, Prompt } from 'react-router-dom';
import FormularioTitulares from "./FormularioTitulares";
import ConfirmationModal from "../../components/Modal/ConfirmationModal";

const ComponentApFacturacionPagadores = (props) => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const [loading, setLoading] = useState(false);
    const [pagadores, setPagadores] = useState([]);
    const [planIndividual, setPlanIndividual] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [primeraCargaCompleta, setPrimeraCargaCompleta] = useState(false);

    const { addToast } = useToasts();
    const refPagadores = useRef();

    useEffect(() => {
        if (!id) history.push('/lista-cotizadores');
    }, [id, history]);

    useEffect(() => {
        recuperarPagadores();
        window.scrollTo(0, 0);

        const handleBeforeUnload = (e) => {
            if (verificarCambios() && !isConfirmed) {
                e.preventDefault();
                e.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);

    useEffect(() => {
        if (isConfirmed) {
            history.push({
                pathname: props.datosCotizador.urlRegresar,
                search: `?id=${id}`,
            });
        }
    }, [isConfirmed]);

    const verificarCambios = () => {
        if (!refPagadores.current || loading || !primeraCargaCompleta) return false;
        const actuales = refPagadores.current.getTitulares();
        if (!actuales) return false;

        // Caso especial: Si no hay pagadores guardados en BD y el form tiene 1 registro vacío (estado inicial del form)
        if (pagadores.length === 0 && actuales.length === 1) {
            const t = actuales[0];
            const estaVacio = !t.cliIdentificacion && !t.nombreCompleto && !t.direccion && !t.celular && !t.email;
            if (estaVacio) return false;
        }

        // Si la cantidad es diferente, hay cambios
        if (actuales.length !== pagadores.length) return true;

        // Comparar contenido básico para detectar cambios
        const initialStr = JSON.stringify(pagadores.map(p => ({
            cliIdentificacion: p.cliIdentificacion || '',
            nombreCompleto: p.nombreCompleto || '',
            direccion: p.direccion || '',
            celular: p.celular || '',
            email: p.email || ''
        })));

        const actualesStr = JSON.stringify(actuales.map(p => ({
            cliIdentificacion: p.cliIdentificacion || '',
            nombreCompleto: p.nombreCompleto || '',
            direccion: p.direccion || '',
            celular: p.celular || '',
            email: p.email || ''
        })));

        return initialStr !== actualesStr;
    };

    const recuperarPagadores = async () => {
        setLoading(true);
        try {
            const response = await fetch(urlObtenerPagadoresAP, {
                method: 'POST',
                body: JSON.stringify({ id }),
            });
            const json = await response.json();
            if (json.transaccion) {
                setPagadores(Array.isArray(json.pagadores) ? json.pagadores : []);
                setPlanIndividual(json.blanket);
            }
        } catch {
            addToast('Error, recuperar Pagadores', { appearance: 'error' });
        }
        setLoading(false);
        setPrimeraCargaCompleta(true);
    };


    const guardarAmbosYContinuar = async () => {
        setLoading(true);
        let datosPagadores = null;

        if (refPagadores.current && typeof refPagadores.current.obtenerDatos === "function") {
            datosPagadores = refPagadores.current.obtenerDatos();
        }

        if (!datosPagadores || !datosPagadores.length) {
            addToast("Debe ingresar un pagador", { appearance: "warning" });
            setLoading(false);
            return;
        }

        try {
            const body = {
                idCarrito: id,
                pagadores: datosPagadores
            };

            const response = await fetch(urlCreaFacturacionAP, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    pasoCarrito: "informacion_pagadores",
                    ...body
                })
            });

            const json = await response.json();

            if (json.transaccion) {
                addToast('Pagadores guardados correctamente', { appearance: 'success' });
                history.push({ pathname: props.datosCotizador.urlSiguiente, search: `?id=${id}` });
            } else {
                addToast(json.mensaje || "Error al guardar", { appearance: 'error' });
            }
        } catch (error) {
            addToast('Error al guardar los datos', { appearance: 'error' });
        }

        setLoading(false);
    };

    return (
        <ContainerApFacturacion paso="planes" titulo={props.datosCotizador.titulo}>
            <main className="cr-app bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <LoadingScreen
                            loading={loading}
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >
                            <Row>
                                <h4 style={{ fontWeight: "bold" }} className="mb-5">
                                    {planIndividual ? "Datos del Pagador" : "Datos de Pagadores"}
                                </h4>
                            </Row>
                            <FormularioTitulares
                                ref={refPagadores}
                                planIndividual={planIndividual}
                                values={pagadores}
                                setLoading={setLoading}
                            />

                            <Card>
                                <CardBody style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Button
                                        onClick={() => {
                                            if (verificarCambios()) {
                                                setShowModal(true);
                                            } else {
                                                history.push({
                                                    pathname: props.datosCotizador.urlRegresar,
                                                    search: `?id=${id}`,
                                                });
                                            }
                                        }}
                                        style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                                    >
                                        <i className="fa fa-chevron-circle-left" /> &nbsp;REGRESAR
                                    </Button>
                                    <Button
                                        onClick={guardarAmbosYContinuar}
                                        style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                                    >
                                        CONTINUAR &nbsp;<i className="fa fa-chevron-circle-right" />
                                    </Button>
                                </CardBody>
                            </Card>

                            <Prompt
                                when={verificarCambios() && !isConfirmed}
                                message="Si regresa se perderán los cambios realizados porque todavía no se ha guardado. Para guardar debe presionar el botón CONTINUAR."
                            />

                            <ConfirmationModal
                                modal={showModal}
                                setModal={setShowModal}
                                title="Confirmación"
                                body="Si regresa se perderán los cambios realizados porque todavía no se ha guardado. Para guardar debe presionar el botón CONTINUAR."
                                buttons={[
                                    {
                                        title: "Sí, salir",
                                        icon: "fa fa-check",
                                        className: "btn btn-primary",
                                        onclick: () => {
                                            setShowModal(false);
                                            setIsConfirmed(true);
                                        }
                                    },
                                    {
                                        title: "Cancelar",
                                        icon: "fa fa-times",
                                        className: "btn btn-secondary",
                                        onclick: () => setShowModal(false)
                                    }
                                ]}
                            />
                        </LoadingScreen>
                    </div>
                </div>
            </main>
        </ContainerApFacturacion>
    );
};

export default ComponentApFacturacionPagadores;
